import "./application-management.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Timeline from "../../../components/timeline/timeline-comp";

export default function ApplicationManagement() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const goToContact = () => {
    navigate("/contact-us");
  };

  const goToAbout = () => {
    navigate("/about-us");
  };

  const timelineData = [
    {
      date: "01",
      title: "Optimized Performance",
      content: "Improved application performance and user experience.",
    },
    {
      date: "02",
      title: "Advanced Security",
      content:
        "Enhanced security measures and protection against cyber threats.",
    },
    {
      date: "03",
      title: "High Availability",
      content: "Reduced downtime and increased availability.",
    },
    {
      date: "04",
      title: "Continuous Improvement",
      content: "Regular application updates and maintenance.",
    },
    {
      date: "05",
      title: "Dedicated Support",
      content:
        "Expert support and troubleshooting for application-related issues.",
    },
  ];

  const challenges = [
    {
      number: "01",
      text: "Struggles with application performance, security, and maintenance.",
    },
    {
      number: "02",
      text: "Application management gaps result in system downtime, decreased productivity, and data breaches.",
    },
    {
      number: "03",
      text: "Difficulty in optimizing legacy systems and ensuring seamless integration with modern technologies.",
    },
  ];

  const cards = [
    {
      icon: "fa-solid fa-gears",
      title: "Application Management",
      text: "Proactive approach to application management.",
    },
    {
      icon: "fa-solid fa-shield-heart",
      title: "Robust Monitoring & Maintenance",
      text: "Thorough assessments, robust monitoring, and maintenance processes.",
    },
    {
      icon: "fa-solid fa-rocket",
      title: "Effortless Application Optimization",
      text: "Optimized, secure, and up-to-date applications without ongoing management burden.",
    },
  ];

  return (
    <div className="main-container">
      {/* main image section */}
      <section className="main-image-section application-management-section">
        <div className="main-image-dark-effect">
          <h6 className="sub-container-sub-heading">{t("Services")}</h6>
          <h1 className="sub-container-heading">{t("Application Management")}</h1>
          <p className="sub-container-desc">
            {t("Application Management ensures applications run efficiently, securely, and reliably enhancing performance, reducing costs, and keeping systems aligned with evolving business needs.")}
          </p>
          <div className="main-img-container-buttons">
            <button
              type="button"
              className="img-contact-btn common-btn-styles"
              onClick={goToContact}
            >
              {t("Contact Us")}
            </button>
            <button
              type="button"
              className="img-about-btn common-btn-styles"
              onClick={goToAbout}
            >
              {t("About Us")}
            </button>
          </div>
        </div>
      </section>

      {/* service overview section */}
      <section className="service-overview">
        <div className="service-overview-width sub-container">
          <div>
            <h1 className="sub-container-heading">{t("Service Overview")}</h1>
          </div>

          <div className="service-img-container">
            <div className="service-image">
              <img
                src="/assets/images/application-management-service-overview.webp"
                alt="Application Management Overview"
              />
            </div>

            {/* Right Content */}
            <div className="service-content">
              <p>
                {t("Our Application Management services ensure your applications run smoothly, securely, and efficiently. We handle monitoring, optimization, and updates to minimize downtime and improve performance, helping businesses stay agile and achieve consistent operational excellence.")}
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("End-to-end application management services ensuring optimal functioning throughout lifecycle.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("Performance, reliability, and security prioritized by our dedicated team of experts.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i>
                  {t("Holistic approach frees up your organization to focus on core business activities.")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/*challenges secton*/}
      <section className="challenges-section sub-container">
        <h2 className="sub-container-heading">{t("Challenges")}</h2>
        <p className="sub-container-desc">
          {t("Common application management challenges organizations face in today’s digital landscape.")}
        </p>
        <div className="challenges-container">
          {challenges.map((item, index) => (
            <div
              className="challenge-box"
              key={index}
              data-number={item.number}
            >
              <p className="challenge-text">{t(item.text)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* how are we solving section */}
      <section className="solving-section">
        <div className="solving-section-container sub-container">
          <h1 className="sub-container-heading">{t("How Are We Solving")}</h1>
          <p className="sub-container-desc">
            {t("We combine strategic insight, technical expertise, and collaboration to deliver application management solutions that enhance performance, ensure reliability, and drive business efficiency through continuous optimization and innovation.")}
          </p>
          <div className="solving-cards">
            {cards.map((card, index) => (
              <div className="solving-card" key={index}>
                <div className="icon-wrapper">
                  <i className={card.icon}></i>
                </div>
                <h3>{t(card.title)}</h3>
                <p>{t(card.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* benefits section */}
      <section className="benefits-section sub-container">
        <h1 className="sub-container-heading">{t("Benefits")}</h1>
        <p className="sub-container-desc">
          {t("With the quality and approach, we would be delivering the best of what you’d need in consulting, suggesting, providing right solutions thus yielding best benefits for your organizations productivity.")}
        </p>
        <div>
          <Timeline timelineData={timelineData} />
        </div>
      </section>
    </div>
  );
}
